import React, { Component } from "react";
import { Container, Grid } from "@material-ui/core";
import NotificationDescription from "./NotificationDescription";
import "./notif-sidebar.css";

const list = [
  {
    title: "Administrative Notices",
    link: "/notifications/administrative",
    type: "administrative",
    code: "COLLEGE_ADMIN_NOTICE",
  },
  {
    title: "Academic Notices",
    link: "/notifications/academic",
    type: "academic",
    code: "COLLEGE_ACADEMIC_NOTICE",
  },
  {
    title: "Events",
    link: "/notifications/events",
    type: "events",
    code: "COLLEGE_EVENTS",
  },
  {
    title: "Principal's Monthly Report",
    link: "/notifications/principal_activity",
    type: "principal_activity",
    code: "PRINCIPAL_ACTIVITY",
  },
  {
    title: "Recent Achievements",
    link: "/notifications/achievements",
    type: "achievements",
    code: "COLLEGE_ACHIEVEMENTS",
  },
  {
    title: "Student Achievements",
    link: "/notifications/sachievements",
    type: "sachievements",
    code: "COLLEGE_STU_ACHIEVEMENTS",
  },
  {
    title: "Employee Achievements",
    link: "/notifications/eachievements",
    type: "eachievements",
    code: "COLLEGE_EMP_ACHIEVEMENTS",
  },
  {
    title: "Downloads",
    link: "/notifications/downloads",
    type: "downloads",
    code: "COLLEGE_DOWNLOADS",
  },
  {
    title: "Activity",
    link: "/notifications/activity",
    type: "activity",
    code: "COLLEGE_ACTIVITY",
  },
  {
    title: "Tender Notices",
    link: "/notifications/tender",
    type: "tender",
    code: "COLLEGE_TENDER",
  },
];


class NotificationComponent extends Component {
  state = {
    link: "",
    code: "",
    title: "",
    year: "",
    isLoaded: false,
    query: "",
  };
  componentDidMount() {
    this.setState({
      isLoaded: false,
    });
    let link = this.props.match.params.link;
    let year = this.props.match.params.year;
    let r = list.filter((el) => el.type == link);
    if (r.length > 0) {
      this.setState({
        link: link,
        year: year,
        code: r[0].code,
        title: r[0].title,
        isLoaded: true,
      });
    } else {
      this.props.history.replace("/");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      this.setState({
        isLoaded: false,
      });
      let link = this.props.match.params.link;
      let year = this.props.match.params.year;
      let r = list.filter((el) => el.type == link);
      if (r.length > 0) {
        this.setState(
          {
            link: link,
            year: year,
            code: r[0].code,
            title: r[0].title,
            isLoaded: false,
          },
          () => this.setState({ isLoaded: true })
        );
      } else {
        this.props.history.replace("/");
      }
    }
  }

  render() {
    const query = this.state.query.trim().toLowerCase();
    const filtered = query
      ? list.filter((el) => el.title.toLowerCase().includes(query))
      : list;

    return (
      <div className="notif-wrap">
        <Container>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <nav className="notif-side">
                <div className="notif-side-head">Notices</div>
                <div className="notif-search">
                  <div className="notif-search-field">
                    <span className="fa fa-search" aria-hidden="true" />
                    <input
                      type="text"
                      className="notif-search-input"
                      placeholder="Search notices..."
                      value={this.state.query}
                      onChange={(e) =>
                        this.setState({ query: e.target.value })
                      }
                    />
                  </div>
                </div>
                <ul className="notif-side-list">
                  {filtered.length === 0 ? (
                    <li className="notif-side-empty">No matching items</li>
                  ) : (
                    filtered.map((el, index) => (
                      <li
                        key={index}
                        className={`notif-side-item${
                          el.type === this.state.link ? " active" : ""
                        }`}
                        onClick={() => this.props.history.push(el.link)}
                      >
                        <span className="notif-dot" />
                        {el.title}
                      </li>
                    ))
                  )}
                </ul>
                <div className="notif-side-foot">
                  <div
                    className="notif-side-contact"
                    onClick={() => this.props.history.push(`/contactus`)}
                  >
                    <span className="fa fa-envelope-o" aria-hidden="true" />
                    Contact Us
                  </div>
                </div>
              </nav>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9} style={{marginBottom: 20}}>

              {this.state.isLoaded ? (
                <NotificationDescription
                  type={this.state.link}
                  year={this.state.year}
                  code={this.state.code}
                  title={this.state.title}
                  history={this.props.history}
                />
              ) : null}
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default NotificationComponent;
